import PuzzleService from '_services/rest/modules/puzzle';

export default {
  state: {
    puzzleNumberSquare: null,
    hasChanges: false,
  },
  mutations: {
    setPuzzleNumberSquare(state, puzzleNumberSquare) {
      state.puzzleNumberSquare = puzzleNumberSquare;
    },
    setHasChanges(state, status) {
      state.hasChanges = status;
    },
  },
  actions: {
    setPuzzleNumberSquare({ commit }, model) {
      commit('setPuzzleNumberSquare', model);
    },
    setHasChanges({ commit }, status) {
      commit('setHasChanges', status);
    },
    getPuzzleNumberSquare({ commit }, id) {
      PuzzleService.getPuzzleById(id)
        .then(response => {
          commit('setPuzzleNumberSquare', response);
          commit('setHasChanges', false);
        });
    },
  },
};
